import TaxTreatmentFields from './TaxTreatmentFields';
import React, { useState, useEffect, useCallback } from "react";
/* global axios */
import api from '../services/apiService';
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { isHoliday } from './holidays'; // Pfad anpassen, z. B. './holidays' oder '../holidays'
import { Helmet } from 'react-helmet';  // Import von React Helmet


// Funktion zur Formatierung des Datums in "TT.MM.JJJJ"
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

// Funktion zur Formatierung von Datum+Uhrzeit in "TT.MM.JJJJ HH:MM"
const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day     = String(date.getDate()).padStart(2, '0');
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const year    = date.getFullYear();
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};



const InterimForm = ({ mode, onSave }) => {
  const { interimId } = useParams();
  const navigate = useNavigate();

  const [interim, setInterim] = useState({
    customerId: "",
    contactId: "",
    lwOperatorId: "",  // Ansprechpartner vor Ort hinzufügen
    deliveryTime: "",
    operationLocation: "",
    notes: "",
    transportNotes: "",
    date: "",
    validUntil: "",
    status: "pending", // Standardstatus für Aufträge
    referenceNumber: "", 
    smartRental: false,            // Neu: SmartRental Checkbox
    obligationInstruction: false,
  });

  // Temporäre Zustände für die Checkboxen
  const [tempIncludeSaturday, setTempIncludeSaturday] = useState(false);
  const [tempIncludeSunday, setTempIncludeSunday] = useState(false);
  const [tempIncludeHolidays, setTempIncludeHolidays] = useState(false);

  // Zustände für Auftragspositionen und verfügbare Artikel
  const [interimItems, setInterimItems] = useState([]);  // State für Auftragspositionen
  const [items, setItems] = useState([]);  // State für alle verfügbaren Artikel
  const [editingRowId, setEditingRowId] = useState(null); // Verfolgt die aktuell bearbeitete Zeile
  const [units, setUnits] = useState([]); // State für Einheiten
  const isEditing = editingRowId !== null;
  const [originalInterimItems, setOriginalInterimItems] = useState([]);
  const [holidays, setHolidays] = useState([]);


function getMaxAvailableQuantity(interimItem) {
  // Wenn keine Verknüpfung zum OrderItem existiert, kein Limit
  if (!interimItem.orderItem) return null;
  const totalOrderQty = interimItem.orderItem.quantity || 0;
  // Ziehe alle anderen Interim-Mengen (für dieses OrderItem, außer aktuelle Zeile) ab
  const usedQty = interimItems
    .filter(i => i.orderItemId === interimItem.orderItemId && i.id !== interimItem.id)
    .reduce((sum, i) => sum + (i.quantity || 0), 0);
  return totalOrderQty - usedQty;
}


  // Feiertage einmal beim Mount laden
useEffect(() => {
  api.get('/holidays')
    .then(res => setHolidays(res.data))
    .catch(console.error);
}, []);

  
  // Speichert nur eine einzelne Zeile
const saveEditedRowInterim = async (rowId) => {
  try {
    // 1) Finde den Eintrag anhand seiner echten DB-ID
    const item = interimItems.find(i => i.id === rowId);
    if (!item) return;

    // Prüfen, ob es sich um einen Mietartikel handelt
    const isRental = item.item?.itemType === "rental";

    // Nur beim Miet-Typ muss rentalPeriodFrom gesetzt sein
    if (isRental && !item.rentalPeriodFrom) {
      return alert("Bitte das Datum ‚Von‘ ausfüllen, bevor Du speicherst.");
    }

    // 2) Baue Payload aus diesem einzelnen Eintrag
    const payload = {
      quantity:           item.quantity,
      unitId:             item.unitId,
      rentalPeriodFrom:   item.rentalPeriodFrom,
      // rentalPeriodTo wird serverseitig neu berechnet, muss nicht gesendet
      rentalTimeFrom:     item.rentalTimeFrom,
      rentalTimeTo:       item.rentalTimeTo,
      includeSaturday:    item.includeSaturday,
      includeSunday:      item.includeSunday,
      includeHolidays:    item.includeHolidays,
      pricePerUnit:       item.pricePerUnit,
      manualPriceActive:  item.manualPriceActive,
      description: item.description,
    };

    // 3) PUT-Request mit der echten DB-id
    await api.put(
      `/interims/${interim.id}/interimitems/${rowId}`,
      payload
    );

     // 4) NEU: updatedBy auf null setzen
        await api.post(`/interims/${interimId}/reset-updatedby`);

    // Auch abhängige MBV-Positionen und die serverseitigen Summen neu laden.
    await fetchInterimItems();

    // 6) Bearbeitungsmodus beenden
    setEditingRowId(null);

  } catch (error) {
    console.error(`Fehler beim Speichern der Position ${rowId}:`, error);
    alert(error.response?.data?.error || `Fehler: Die Änderung der Position ${rowId} konnte nicht gespeichert werden.`);
  }
};
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  // Hilfsfunktion zum Parsen von Zeitstrings "HH:MM" in Millisekunden seit Mitternacht
  const parseTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return (hours * 60 + minutes) * 60 * 1000; // Millisekunden
  };



  

  /**
 * Prüft, ob ein JS-Date-Objekt auf einen Feiertag fällt,
 * basierend auf dem im State geladenen holidays-Array.
 */
const isHolidayDate = (date) => {
  const m = date.getMonth();    // JS: 0 = Januar … 11 = Dezember
  const d = date.getDate();     // 1–31
  return holidays.some(h =>
    Number(h.month) === m &&
    Number(h.day)   === d
  );
};




  const updateRentalPeriodTo = useCallback(() => {
  // Filtern Sie alle interimItems vom Typ "rental"
  const rentalItems = interimItems.filter(item => {
    const correspondingItem = items.find(i => i.id === item.itemId);
    return correspondingItem && correspondingItem.itemType === "rental";
  });

  let updated = false; // Flag zur Überprüfung, ob eine Aktualisierung notwendig ist

  // Erstellen Sie eine neue Version von interimItems mit aktualisierten rentalPeriodTo
  const newInterimItems = interimItems.map(item => {
    if (rentalItems.some(rentalItem => rentalItem.id === item.id)) {
      if (item.rentalPeriodFrom && item.quantity) {
        const startDate = new Date(item.rentalPeriodFrom);
        let rentalDays = item.quantity; // Anzahl der gewünschten Tage oder Stunden
        let isTimeBased = false; // Flag zur Bestimmung, ob die Einheit zeitbasiert ist

        // Überprüfen, ob die Einheit zeitbasiert ist (angenommen, unitId === 27 bedeutet Stunden)
        if (item.unit && item.unit.id === 27) {
          isTimeBased = true;

          // Prüfen, ob beide Zeitfelder ausgefüllt sind und die Einheit auf Zeit steht
          if (item.rentalTimeFrom && item.rentalTimeTo) {
            const timeFrom = parseTime(item.rentalTimeFrom);
            const timeTo = parseTime(item.rentalTimeTo);

            // Berechnung der Stunden im Zeitfenster
            const hoursPerDay = (timeTo - timeFrom) / (1000 * 60 * 60); // Annahme: Zeit als "HH:MM" String
            console.log(`Berechnung für item.id=${item.id}: timeFrom=${item.rentalTimeFrom}, timeTo=${item.rentalTimeTo}, hoursPerDay=${hoursPerDay}`);

            if (hoursPerDay > 0) {
              rentalDays = Math.ceil(item.quantity / hoursPerDay);
            } else {
              // Falls timeTo kleiner oder gleich timeFrom ist, Standard von 24 Stunden verwenden
              rentalDays = Math.ceil(item.quantity / 24);
            }
          } else {
            // Wenn nur eines oder keine Zeitfelder ausgefüllt ist, Standard 24 Stunden verwenden
            rentalDays = Math.ceil(item.quantity / 24);
          }
        }
        
        console.log(`item.id=${item.id}: startDate=${startDate.toISOString()}, rentalDays=${rentalDays}`);

        // === NEU: Korrekte Miettage-Zählung wie im Backend ===
        // 1. Alle include-Werte in echte Booleans
        const includeSundayBool   = item.includeSunday === true || item.includeSunday === "true";
        const includeSaturdayBool = item.includeSaturday === true || item.includeSaturday === "true";
        const includeHolidaysBool = item.includeHolidays === true || item.includeHolidays === "true";

        // 2. Ersten erlaubten Miettag suchen, dann weiterzählen
        let cursor = new Date(startDate);

        // Suche den ersten erlaubten Tag
        while (true) {
          const dow = cursor.getDay(); // 0=So, 6=Sa
          const isHoliday = isHolidayDate(cursor);
          const allowed =
            (dow >= 1 && dow <= 5 && (!isHoliday || includeHolidaysBool)) ||
            (dow === 6 && includeSaturdayBool) ||
            (dow === 0 && includeSundayBool) ||
            (includeHolidaysBool && isHoliday);
          if (allowed) break;
          cursor.setDate(cursor.getDate() + 1);
        }

        // Jetzt noch (rentalDays-1) erlaubte Miettage zählen:
        let daysLeft = rentalDays - 1;
        while (daysLeft > 0) {
          cursor.setDate(cursor.getDate() + 1);
          const dow = cursor.getDay();
          const isHoliday = isHolidayDate(cursor);
          const allowed =
            (dow >= 1 && dow <= 5 && (!isHoliday || includeHolidaysBool)) ||
            (dow === 6 && includeSaturdayBool) ||
            (dow === 0 && includeSundayBool) ||
            (includeHolidaysBool && isHoliday);
          if (allowed) daysLeft--;
        }

        // currentDate/cursor ist jetzt der letzte Miettag
        const rentalPeriodToDate = new Date(cursor);
        const formattedRentalPeriodTo = rentalPeriodToDate.toISOString().split('T')[0];

        // Überprüfen, ob eine Aktualisierung notwendig ist
        if (item.rentalPeriodTo !== formattedRentalPeriodTo) {
          updated = true;
          return { ...item, rentalPeriodTo: formattedRentalPeriodTo };
        }
      }
    }
    return item;
  });

  // Aktualisieren Sie den State nur, wenn eine Änderung vorgenommen wurde
  if (updated) {
    setInterimItems(newInterimItems);
  }
}, [interimItems, items, parseTime, isHolidayDate]);





  // Funktion zur Aktualisierung der Einheit im Backend
  const updateInterimItemUnit = async (interimId, InterimItemId, newUnitId, newQuantity) => {
    try {
      const payload = {
        id: InterimItemId,
        unitId: newUnitId,
        quantity: newQuantity,  // Hier fügst du die Menge hinzu
      };

      const response = await api.put(
        `/interims/${interimId}/interimitems/${InterimItemId}`, 
        payload
      );
      console.log('Einheit und Menge erfolgreich aktualisiert:', response.data);
      await fetchInterimItems();
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Einheit:', error);
    }
  };

  const getMatchingPricing = (item, quantity, newUnitId) => {
    // Überprüfen, ob die Preisstaffelung existiert für die neue Einheit (newUnitId)
    const pricing = item.item.machineType?.typePricings.find((pricing) => {
      return quantity >= pricing.minQuantity && quantity <= pricing.maxQuantity && pricing.unitId === newUnitId;
    });

    if (pricing) {
      const pricePerUnit = pricing.pricePerUnit;
      const total = pricePerUnit * quantity;
      return { pricePerUnit, total };
    } else {
      // Wenn keine Preisstaffelung gefunden wird, setze Standardwerte
      return { pricePerUnit: 0, total: 0 };
    }
  };

  // Auftragspositionen entfernen
  const removeInterimItem = async (InterimItemId) => {
    console.log("Remove-Handler aufgerufen mit ID:", InterimItemId);
    try {
      console.log(`Entferne Auftragsposition mit ID: ${InterimItemId} für Auftrag ID: ${interim.id}`);

      // API-Aufruf, um die Auftragsposition zu entfernen
      const response = await api.delete(`/interims/${interim.id}/interimitems/${InterimItemId}`);
      console.log('API-Antwort beim Entfernen:', response.data, 'Status:', response.status);

      // Überprüfen, ob die Antwort erfolgreich war
      if (response.status === 200 || response.status === 204) {
        await fetchInterimItems();

        console.log(`Auftragsposition mit ID ${InterimItemId} erfolgreich entfernt.`);
      } else {
        console.error(`Fehler beim Entfernen der Auftragsposition: Unerwarteter Status ${response.status}`);
      }
    } catch (error) {
      // Detaillierte Fehlerbehandlung und Logausgabe
      console.error('Fehler beim Entfernen der Auftragsposition:', error.message || error);

      // Benutzer über den Fehler informieren
      alert(error.response?.data?.error || 'Fehler: Die Auftragsposition konnte nicht entfernt werden. Bitte versuchen Sie es später erneut.');
    }
  };

  // 0. Interim selbst laden (Kopfdaten)
useEffect(() => {
  if (mode === 'edit' && interimId) {
    api.get(`/interims/${interimId}`)
      .then(res => {
        console.log("💾 Raw Interim-Objekt:", res.data);
        setInterim(res.data);
      })
      .catch(err => {
        console.error('Fehler beim Laden der Zwischenabrechnung:', err);
        alert('Konnte Zwischenabrechnung nicht laden.');
      });
  }
}, [mode, interimId]);

// Funktion zum Abrufen der Zwischenabrechnungs-Positionen
const fetchInterimItems = async () => {
  try {
    // nutzt jetzt exakt /interims/:interimId/interimitems
    const [response, header] = await Promise.all([
      api.get(`/interims/${interimId}/interimitems`),
      api.get(`/interims/${interimId}`),
    ]);
    if (!Array.isArray(response.data)) return;

    const itemsFromServer = response.data.map(item => ({
      ...item,
      tempId: item.id,
      manualPriceActive: !!item.manualPriceActive
    }));

    setInterimItems(
      itemsFromServer.sort((a, b) => a.position - b.position)
    );
    setInterim(prev => ({ ...prev, totalNet: header.data.totalNet,
      vatAmount: header.data.vatAmount, totalGross: header.data.totalGross,
      invoices: header.data.invoices }));
  } catch (error) {
    console.error('Fehler beim Abrufen der Zwischenabrechnungs-Positionen:', error);
  }
};


// 1. InterimItems abrufen, sobald interim.id gesetzt ist
useEffect(() => {
  if (interim.id) {
    fetchInterimItems();  // <-- ruft jetzt /interims/:interimId/interimitems
    fetchUnits();
  }
}, [interim.id]);

// 2. rentalPeriodTo berechnen, sobald sich interimItems ändern
useEffect(() => {
  if (interimItems.length > 0) {
    updateRentalPeriodTo();
    console.log('Aktuelle Zwischenabrechnungs-Positionen:', interimItems);
  }
}, [interimItems]);

// 3. Artikel laden (einmalig beim Mount)
useEffect(() => {
  const fetchItems = async () => {
    try {
      const response = await api.get('/items');
      // Nur aktive Artikel
      const activeItems = response.data.filter(item => item.deactivated === false);
      setItems(activeItems);
    } catch (error) {
      console.error('Fehler beim Laden der Artikel:', error);
    }
  };
  fetchItems();
}, []);

// 4. Global Checkbox-State aus interimItems übernehmen
useEffect(() => {
  if (interimItems.length > 0) {
    setTempIncludeSaturday(interimItems.some(item => item.includeSaturday));
    setTempIncludeSunday(interimItems.some(item => item.includeSunday));
    setTempIncludeHolidays(interimItems.some(item => item.includeHolidays));
  }
}, [interimItems]);








  const getUnitId = (item) => {
    // Überprüfe, ob eine Einheit im TypePricing existiert
    const typePricingUnitId = item?.machineType?.typePricings?.[0]?.unitId;

    // Falls keine Einheit im TypePricing gefunden, überprüfe das TransportPricing
    const transportUnitId = item?.transportPricings?.[0]?.unitId;

    // Setze die Einheit für Versicherungsartikel auf "Prozent" (id: 33)
    if (item?.itemType === 'insurance') {
      return 33;
    }

    // Wenn keine Einheit gefunden wurde, gebe null zurück
    return typePricingUnitId || transportUnitId || null;
  };

  const handleCheckboxChange = async (InterimItemId, field, value) => {
    try {
      // Aktualisieren des interimItems-Zustands lokal
      const updatedInterimItems = interimItems.map(item => {
        if (item.id === InterimItemId) {
          return { ...item, [field]: value };
        }
        return item;
      });
      setInterimItems(updatedInterimItems);
      console.log(`Checkbox '${field}' für Auftragsposition ${InterimItemId} auf ${value} gesetzt.`);

      // Berechnung der rentalPeriodTo nach der Änderung
      updateRentalPeriodTo(updatedInterimItems);

      // Speichern der Änderung im Backend
      const updatedItem = updatedInterimItems.find(item => item.id === InterimItemId);
      if (updatedItem) {
        await api.put(`/interims/${interimId}/interimitems/${InterimItemId}`, updatedItem);
        await fetchInterimItems();
        console.log(`Auftragsposition ${InterimItemId} erfolgreich aktualisiert.`);
      }
    } catch (error) {
      console.error(`Fehler beim Aktualisieren der Auftragsposition ${InterimItemId}:`, error);
      alert(`Fehler: Die Änderung an Auftragsposition ${InterimItemId} konnte nicht gespeichert werden.`);
    }
  };

  // Funktion zur globalen Aktualisierung der Checkbox-Zustände in allen interimItems
  const handleGlobalCheckboxChange = async (field, value) => {
    try {
       // Setze den globalen Zustand
    if (field === 'includeSaturday') setTempIncludeSaturday(value);
    if (field === 'includeSunday') setTempIncludeSunday(value);
    if (field === 'includeHolidays') setTempIncludeHolidays(value);

    // Aktualisiere alle InterimItems
      const updatedItems = interimItems.map(item => ({
        ...item,
        [field]: value,
      }));

      console.log("Vor setInterimItems (aktualisiert):", updatedItems);
      setInterimItems(updatedItems);

      // Backend-Anfrage
      const updatePromises = updatedItems.map(item =>
        api.put(`/interims/${interimId}/interimitems/${item.id}`, item)
      );
      await Promise.all(updatePromises);

      await fetchInterimItems();

      console.log("Nach Backend-Update erfolgreich!");
    } catch (error) {
      console.error(`Fehler beim Aktualisieren von ${field}:`, error);
    }
  };


  // === ganz unten in OfferForm.js, nach Deinem useEffect fürs offerItems-Update ===
  // immer dann neu berechnen, wenn sich includeSaturday/includeSunday/includeHolidays
  // für genau diejenige Zeile ändern, die gerade im Bearbeitungsmodus ist:
  useEffect(() => {
    if (!editingRowId) return;
    // finde die im Edit befindliche Zeile
    const current = interimItems.find(i => i.id === editingRowId);
    if (!current) return;
  
    // nur neu rechnen, wenn auch wirklich einer der Flags sich geändert hat
    updateRentalPeriodTo();
  }, [
    // beobachte nur die drei Flags UND rentalPeriodFrom/quantity für die editierte Zeile
    interimItems.find(i => i.id === editingRowId)?.includeSaturday,
    interimItems.find(i => i.id === editingRowId)?.includeSunday,
    interimItems.find(i => i.id === editingRowId)?.includeHolidays,
    interimItems.find(i => i.id === editingRowId)?.rentalPeriodFrom,
    interimItems.find(i => i.id === editingRowId)?.quantity,
  ]);




  // Einheiten abrufen und im Zustand speichern
  const fetchUnits = async () => {
    try {
      const response = await api.get('/units'); // Beispiel-Endpoint zum Abrufen der Einheiten
      console.log("Geladene Einheiten:", response.data);
      setUnits(response.data); // Setze den Zustand für die Einheiten
    } catch (error) {
      console.error('Fehler beim Abrufen der Einheiten:', error);
    }
  };

  // useEffect, der die Berechnung von rentalPeriodTo auslöst, wenn sich interimItems ändern
  useEffect(() => {
    if (interimItems.length > 0) {
      updateRentalPeriodTo(); // Berechne rentalPeriodTo, wenn interimItems sich ändern
    }
  }, [interimItems]);

  // Auftragsposition bearbeiten
  const editInterimItem = (InterimItemId) => {
    console.log("Edit-Handler aufgerufen mit ID:", InterimItemId);
    
    // Setze die ID der Zeile, die bearbeitet werden soll
    setEditingRowId(InterimItemId);

    // Finde die Auftragsposition
    const InterimItemToEdit = interimItems.find((item) => item.id === InterimItemId);
    if (InterimItemToEdit) {
      // Initialisiere die temporären Checkboxwerte mit den interimItem-Werten
      setTempIncludeSaturday(InterimItemToEdit.includeSaturday);
      setTempIncludeSunday(InterimItemToEdit.includeSunday);
      setTempIncludeHolidays(InterimItemToEdit.includeHolidays);
    } else {
      // Fehlerbehandlung
      console.error("Auftragsposition nicht gefunden:", InterimItemId);
      console.log("Aktuelle Auftragspositionen:", interimItems); // Logge den Zustand von interimItems
    }
  };

  /// Auftragsposition Einheit im Backend aktualisieren
  const saveInterimItemUnit = async (interimId, interimItems) => {
    try {
      // Überprüfen, ob interimId vorhanden ist
      if (!interimId) {
        throw new Error("InterimId ist nicht definiert");
      }

      // Überprüfen, ob interimItems ein gültiges Array ist
      if (!Array.isArray(interimItems) || interimItems.length === 0) {
        throw new Error("InterimItems ist nicht definiert oder kein gültiges Array");
      }

      // Optional: Jede Auftragsposition überprüfen, ob sie eine id und unitId hat
      interimItems.forEach((item, index) => {
        if (!item.id) {
          throw new Error(`Fehlende id für Auftragsposition an Index ${index}: ${JSON.stringify(item)}`);
        }

        // Überprüfen, ob die Einheit korrekt gesetzt ist
        if (item.unitId === undefined || item.unitId === null) {
          throw new Error(`Fehlende unitId für Auftragsposition an Index ${index}: ${JSON.stringify(item)}`);
        }

        // Spezielle Behandlung für Versicherungsartikel (unitId muss 33 sein)
        if (item.itemType === 'insurance' && item.unitId !== 33) {
          item.unitId = 33;  // Setze die unitId auf 33 für Versicherungsartikel
        }
      });

      // Backend-URL korrekt formatieren und die Auftragspositionen als Array senden
      const response = await api.put(`/interims/${interimId}/interimitems`, interimItems);
      console.log(`Auftragspositionen erfolgreich gespeichert:`, response.data);

    } catch (error) {
      console.error(`Fehler beim Speichern der Auftragspositionen:`, error.message);
    }
  };

  const saveChanges = async () => {
  try {
    console.log('Speichere Daten der Auftragspositionen:', interimItems);

    // 1) alle Items speichern
    const updatePromises = interimItems.map(async (item) => {
      const payload = {
        id: item.id,
        itemId: item.itemId,
        quantity: item.quantity,
        unitId: item.unitId,
        rentalPeriodFrom: item.rentalPeriodFrom,
        rentalPeriodTo: item.rentalPeriodTo,
        rentalTimeFrom: item.rentalTimeFrom,
        rentalTimeTo: item.rentalTimeTo,
        includeSaturday: item.includeSaturday,
        includeSunday: item.includeSunday,
        includeHolidays: item.includeHolidays,
        pricePerUnit: item.pricePerUnit,
        manualPriceActive: item.manualPriceActive,
        description: item.description,
      };

      console.log("Payload vor PUT-Anfrage:", payload);

      await api.put(
        `/interims/${interim.id}/interimitems/${item.id}`,
        payload
      );
      console.log(`Position ${item.id} erfolgreich gespeichert.`);
    });

    await Promise.all(updatePromises);
    console.log('Alle Positionen erfolgreich gespeichert.');

    // 2) updatedBy auf null setzen!
    await api.post(`/interims/${interim.id}/reset-updatedby`);
    console.log('updatedBy auf null zurückgesetzt.');

    // 2) Interim-Header aktualisieren, damit updatedBy gesetzt wird
    const headerPayload = {
      // hier alle Felder mitgeben, die Dein PUT-Endpoint erwartet
      referenceNumber: interim.referenceNumber,
      date:             interim.date,
      notes:            interim.notes,
      status:           interim.status,
      smartRental:      interim.smartRental,
      // … und alles andere, was Du im Backend updaten willst …
    };
    console.log('Interim-Header aktualisieren mit:', headerPayload);
    await api.put(`/interims/${interim.id}`, headerPayload);
    console.log('Interim-Header erfolgreich gespeichert.');

    // 3) Items neu laden und State mergen
    const updatedResponse = await api.get(`/interims/${interim.id}/items`);
    console.log('Backend-Daten vor Verarbeitung:', updatedResponse.data);

    if (Array.isArray(updatedResponse.data)) {
      const mergedItems = updatedResponse.data.map(backendItem => {
        const localItem = interimItems.find(item => item.id === backendItem.id);
        return {
          ...backendItem,
          manualPriceActive: localItem?.manualPriceActive ?? backendItem.manualPriceActive
        };
      });
      setInterimItems(
        mergedItems.sort((a, b) => a.position - b.position)
      );
      console.log('InterimItems nach Backend-Synchronisation (mit merge):', mergedItems);
    }

    await fetchInterimItems();

    alert('Alle Änderungen wurden erfolgreich gespeichert!');
    setEditingRowId(null);

 } catch (error) {
  console.error('Fehler beim Speichern der Änderungen:', error);

  // Fehlertext aus Backend holen, wenn vorhanden
  let msg = 'Fehler: Änderungen konnten nicht gespeichert werden.';
  if (error.response && error.response.data && error.response.data.error) {
    msg = `Fehler: ${error.response.data.error}`;
  }
  alert(msg);
}
};


  // Abbrechen der Bearbeitung
  const handleEditClick = (rowId) => {
    if (!interimItems || interimItems.length === 0) {
      console.warn("Keine InterimItems verfügbar, um den Bearbeitungsmodus zu starten.");
      return;
    }

    console.log("Speichern der ursprünglichen InterimItems vor Bearbeitung:", interimItems);

    // Speichere die ursprünglichen InterimItems als Kopie
    setOriginalInterimItems([...interimItems]);

    // Finde das InterimItem, das bearbeitet wird, und setze die temporären Zustände
    const itemToEdit = interimItems.find(item => item.id === rowId);
    if (itemToEdit) {
      console.log("Bearbeitung starten für:", itemToEdit);

      // Initialisiere die temporären Checkboxwerte mit den interimItem-Werten
      setTempIncludeSaturday(itemToEdit.includeSaturday);
      setTempIncludeSunday(itemToEdit.includeSunday);
      setTempIncludeHolidays(itemToEdit.includeHolidays);
    } else {
      console.warn(`Kein InterimItem mit der ID ${rowId} gefunden.`);
    }

    setEditingRowId(rowId);
  };

  useEffect(() => {
    if (editingRowId) {
      console.log("Bearbeitungsmodus aktiviert. Speichere aktuelle InterimItems:", interimItems);
      setOriginalInterimItems([...interimItems]); // Kopie der aktuellen InterimItems speichern
    }
  }, [editingRowId, interimItems]);

  const handleCancelEdit = () => {
    console.log("Abbrechen gedrückt. Original InterimItems:", originalInterimItems);

    if (!originalInterimItems || originalInterimItems.length === 0) {
      console.warn("Keine Originaldaten zum Zurücksetzen gefunden.");
      return;
    }

    // Setze interimItems auf die ursprünglichen Werte zurück
    setInterimItems([...originalInterimItems]);
    console.log("InterimItems nach Abbrechen zurückgesetzt auf:", originalInterimItems);

    // Beende den Bearbeitungsmodus
    setEditingRowId(null);
  };

  const handleSaveEditedInterimItem = async () => {
    try {
      // Aktualisieren der interimItems mit den temporären Zuständen
      const updatedInterimItems = interimItems.map(item => {
        if (item.id === editingRowId) {
          return {
            ...item,
            includeSaturday: tempIncludeSaturday,
            includeSunday: tempIncludeSunday,
            includeHolidays: tempIncludeHolidays,
          };
        }
        return item;
      });

      // Führen Sie die Berechnung durch
      updateRentalPeriodTo(updatedInterimItems);

      // Speichern Sie alle interimItems im Backend
      const updatePromises = updatedInterimItems.map(item =>
        api.put(`/interims/${interimId}/interimitems/${item.id}`, item)
      );
      await Promise.all(updatePromises);

       await api.post(`/interims/${interimId}/reset-updatedby`);
      // Aktualisieren Sie den Frontend-Zustand nach erfolgreichem Speichern
      await fetchInterimItems();

      // Beenden Sie den Bearbeitungsmodus
      setEditingRowId(null);

      alert('Alle Änderungen wurden erfolgreich gespeichert!');
    } catch (error) {
      console.error('Fehler beim Speichern der bearbeiteten Auftragsposition:', error);
      alert('Fehler: Die bearbeiteten Änderungen konnten nicht gespeichert werden.');
    }
  };

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [lwOperatorContacts, setLWOperatorContacts] = useState([]); // State für Ansprechpartner vor Ort (LW-Bediener)
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedLWOperator, setSelectedLWOperator] = useState(null); // State für den ausgewählten Ansprechpartner vor Ort
  const [isLoading, setIsLoading] = useState(true);
  const [contactsLoadedForCustomer, setContactsLoadedForCustomer] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Kunden laden (nur einmal beim initialen Rendern)
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        console.log("Kunden werden geladen...");
        const customersResponse = await api.get("/customers");
        const loadedCustomers = customersResponse.data;
        setCustomers(loadedCustomers);
        setFilteredCustomers(loadedCustomers); // Zu Beginn alle Kunden anzeigen
        console.log("Kunden geladen:", loadedCustomers);
      } catch (error) {
        console.error("Fehler beim Laden der Kunden:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Funktion, um die Kontakte eines bestimmten Kunden zu laden
  const loadContactsForCustomer = useCallback(async (customerId, contactId = null) => {
    try {
      if (!customerId || customerId === contactsLoadedForCustomer) return;

      console.log(`Lade Kontakte für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=Besteller`
      );
      setCustomerContacts(response.data);
      setContactsLoadedForCustomer(customerId);
      console.log("Kontakte geladen:", response.data);

      if (contactId) {
        const selectedContact = response.data.find(
          (contact) => contact.id.toString() === contactId.toString()
        );
        if (selectedContact) {
          setSelectedContact(selectedContact);
          console.log("Ausgewählter Besteller gesetzt:", selectedContact);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der Besteller:", error);
    }
  }, [contactsLoadedForCustomer]);

  // Funktion, um die LW-Bediener-Kontakte eines bestimmten Kunden zu laden
  const loadLWOperatorContacts = useCallback(async (customerId, lwOperatorId = null) => {
    try {
      if (!customerId) return;

      console.log(`Lade LW-Bediener für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=LW-Bediener`
      );
      setLWOperatorContacts(response.data);
      console.log("LW-Bediener geladen:", response.data);

      if (lwOperatorId) {
        const selectedLWOperator = response.data.find(
          (contact) => contact.id.toString() === lwOperatorId.toString()
        );
        if (selectedLWOperator) {
          setSelectedLWOperator(selectedLWOperator);
          console.log("Ausgewählter Ansprechpartner vor Ort gesetzt:", selectedLWOperator);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der LW-Bediener:", error);
    }
  }, [setLWOperatorContacts]);

  // Auftrag und zugehörige Daten laden, falls im Bearbeitungsmodus
  useEffect(() => {
    if (mode === "edit" && interimId && customers.length > 0 && !initialDataLoaded) {
      const fetchInterimData = async () => {
        try {
          console.log("Auftrag wird geladen...");
          const InterimResponse = await api.get(`/interims/${interimId}`);
          const fetchedInterim = InterimResponse.data;

          const timeNoSeconds = fetchedInterim.deliveryTime
   ? fetchedInterim.deliveryTime.slice(0, 5)
   : null;

          console.log("Geladener Auftrag:", fetchedInterim);

          setInterim({
            ...fetchedInterim,
            deliveryTime: timeNoSeconds,
            rentalPeriodFrom: normalizeDate(fetchedInterim.rentalPeriodFrom),
            rentalPeriodTo: normalizeDate(fetchedInterim.rentalPeriodTo),
          });

          console.log("Auftrag gesetzt:", fetchedInterim);

          if (fetchedInterim.customerId) {
            const selectedCustomer = customers.find(
              (customer) => customer.id.toString() === fetchedInterim.customerId.toString()
            );
            if (selectedCustomer) {
              setSelectedCustomer(selectedCustomer);
              console.log("Ausgewählter Kunde gesetzt:", selectedCustomer);
              // Kontakte und LW-Bediener nur einmal laden
              await loadContactsForCustomer(fetchedInterim.customerId, fetchedInterim.contactId);
              await loadLWOperatorContacts(fetchedInterim.customerId, fetchedInterim.lwOperatorId);
            }
          }
        } catch (error) {
          console.error("Fehler beim Laden des Auftrags:", error);
        } finally {
          setInitialDataLoaded(true);
          setIsLoading(false);
        }
      };

      fetchInterimData();
    } else {
      setIsLoading(false);
    }
  }, [mode, interimId, customers, initialDataLoaded, loadContactsForCustomer, loadLWOperatorContacts]);

  // Funktion, um das Datum zu normalisieren
  const normalizeDate = (dateString) => dateString?.split("T")[0] || "";

  // Funktion zum Filtern der Kunden (debounced, um unnötige Anfragen zu vermeiden)
  const filterCustomers = debounce((inputValue) => {
    if (inputValue.trim() === "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter((customer) =>
        `${customer.company} ${customer.customerNumber} ${customer.firstName} ${customer.lastName} ${customer.street} ${customer.postalCode} ${customer.city}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, 300);

  // Handle search field changes
  const handleCustomerSearchChange = (inputValue) => {
    filterCustomers(inputValue);
  };

  // Auftrag auswählen und alle zugehörigen Daten laden
  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setInterim((prev) => ({
        ...prev,
        customerId: "",
        contactId: "", // Kontakt ebenfalls zurücksetzen
        lwOperatorId: "", // Ansprechpartner vor Ort zurücksetzen
      }));
      setSelectedCustomer(null);
      setCustomerContacts([]);
      setSelectedContact(null);
      setLWOperatorContacts([]);
      setSelectedLWOperator(null);
      return;
    }

    const selectedCustomerId = selectedOption.value;

    // Den neuen Kunden setzen und Besteller zurücksetzen
    setInterim((prev) => ({
      ...prev,
      customerId: selectedCustomerId,
      contactId: "", // Zurücksetzen des Bestellers, da der Kunde geändert wurde
      lwOperatorId: "", // Zurücksetzen des LW-Bedieners
    }));

    // Den ausgewählten Kunden im Zustand speichern und anzeigen
    const selected = customers.find(
      (customer) => customer.id.toString() === selectedCustomerId.toString()
    );
    if (selected) {
      setSelectedCustomer(selected);
      console.log("Ausgewählter Kunde geändert:", selected);
      // Kontakte für den neuen Kunden laden
      loadContactsForCustomer(selectedCustomerId);
      loadLWOperatorContacts(selectedCustomerId);
    } else {
      setSelectedCustomer(null);
      console.log("Kunde konnte nicht gefunden werden");
    }
  };

  // Funktion zum Aktualisieren von Feldern (z.B. date, deliveryTime, etc.)
  const handleChange = (e) => {
    const { name, value } = e.target;

    setInterim(prev => {
      const updatedInterim = {
        ...prev,
        [name]:
     name === "deliveryTime"
       ? (value && value.length > 0 ? value : null)
       : value, // Aktualisiere das geänderte Feld
      };

      // Wenn rentalPeriodFrom geändert wurde, berechne rentalPeriodTo
      if (name === 'rentalPeriodFrom') {
        updateRentalPeriodTo(); // Berechne rentalPeriodTo basierend auf rentalPeriodFrom
      }

      return updatedInterim;
    });
  };

  // Besteller ändern
  const handleContactChange = (e) => {
    const selectedContactId = e.target.value;
    setInterim((prev) => ({
      ...prev,
      contactId: selectedContactId,
    }));

    const selected = customerContacts.find(
      (contact) => contact.id.toString() === selectedContactId.toString()
    );
    if (selected) {
      setSelectedContact(selected);
      console.log("Ausgewählter Besteller geändert:", selected);
    } else {
      setSelectedContact(null);
      console.log("Besteller konnte nicht gefunden werden");
    }
  };

  // Ansprechpartner vor Ort ändern
  const handleLWOperatorChange = (e) => {
    const selectedLWOperatorId = e.target.value;
    setInterim((prev) => ({
      ...prev,
      lwOperatorId: selectedLWOperatorId,
    }));

    const selected = lwOperatorContacts.find(
      (contact) => contact.id.toString() === selectedLWOperatorId.toString()
    );
    if (selected) {
      setSelectedLWOperator(selected);
      console.log("Ausgewählter Ansprechpartner vor Ort geändert:", selected);
    } else {
      setSelectedLWOperator(null);
      console.log("Ansprechpartner vor Ort konnte nicht gefunden werden");
    }
  };

  // Funktion, um Gesamtsummen zu berechnen und im Backend zu speichern
  const saveInterimTotals = async () => {
    if (interim.invoices?.length) return true;
    try {
      await api.put(`/interims/${interim.id}`, {});
      await fetchInterimItems();
      console.log('Gesamtsummen erfolgreich gespeichert.');
    } catch (error) {
      console.error('Fehler beim Speichern der Gesamtsummen:', error);
      alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
    }
  };

  const updateInterimAndSaveTotals = async () => {
    // Zuerst die InterimItems aktualisieren
    const InterimItemsUpdateResponse = await api.put(
      `/interims/${interim.id}/interimitems`, 
      interimItems
    );

    // Berechnung der neuen Gesamtsumme
    const totalNet = interimItems.reduce((sum, item) => sum + (item.total || 0), 0);
    const vatRate = interim.vatRate ?? 19;
    const vatAmount = totalNet * (vatRate / 100);
    const totalGross = totalNet + vatAmount;

    // Danach die Interim-Tabelle mit den neuen Gesamtwerten aktualisieren
    try {
      const response = await api.put(`/interims/${interim.id}`, {
        totalNet,
        vatAmount,
        totalGross,
      });
      console.log('Gesamtsummen erfolgreich gespeichert:', response.data);
    } catch (error) {
      console.error('Fehler beim Speichern der Gesamtsummen:', error);
      alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
    }
  };

  const handleBackButtonClick = async () => {
    if (await saveInterimTotals() === false) return; // Speichern der Gesamtsummen
    navigate('/interims'); // Zurück zur Auftragsübersicht
  };

  // Auftrag speichern
  const handleSave = async () => {
    if (!interim.customerId) {
      alert("Bitte wählen Sie einen Kunden aus.");
      return;
    }
    
    console.log("Auftrag, der gespeichert wird:", interim);

    try {
      const InterimDate = interim.date || new Date().toISOString(); // Setze das Auftragsdatum, falls es nicht existiert
      const validUntilDate = interim.validUntil || new Date(new Date(InterimDate).setDate(new Date(InterimDate).getDate() + 14)).toISOString(); // Setze Auftragsgültigkeit, falls nicht vorhanden

      // Wenn der Auftrag im Draft-Status ist, setzen wir beim Speichern den Status auf 'pending',
      // damit im Backend die Auftragsnummer vergeben wird.
      const finalStatus = interim.status === 'draft' ? 'pending' : interim.status;

    
      const payload = {
        ...interim,
        date: InterimDate,
        validUntil: validUntilDate,
        contactId: interim.contactId || null,
        lwOperatorId: interim.lwOperatorId || null,
        status: finalStatus,
        includeSaturday: interim.includeSaturday,  // Globalen Zustand integrieren
      includeSunday: interim.includeSunday,
      includeHolidays: interim.includeHolidays,
      };

       // 1) Speichern und InterimNumber ermitteln
     let InterimNumber;
     if (mode === "edit") {
       await api.put(`/interims/${interimId}`, payload);
       alert("Auftrag erfolgreich aktualisiert!");
       // Wir nehmen die Nummer aus dem State (interim.InterimNumber)
       InterimNumber = interim.InterimNumber;
     } else {
       const response = await api.post("/interims", payload);
       InterimNumber = response.data.InterimNumber;
       alert(`Auftrag erfolgreich erstellt! Auftragsnummer: ${InterimNumber}`);
     }

      // Gesamtsummen-Funktion aufrufen
      await saveInterimTotals();

      if (onSave) onSave();
      navigate(`/interims?InterimNumber=${encodeURIComponent(InterimNumber)}`);
    } catch (error) {
      console.error("Fehler beim Speichern des Auftrags:", error);
      alert(error.response?.data?.error || "Der Beleg konnte nicht gespeichert werden.");
    }
  };

  // Kundenoptionen für React Select
  const customerOptions = filteredCustomers.map((customer) => ({
    value: customer.id,
    label: `${customer.company} (${customer.customerNumber})`,
  }));

  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div key={interimId} className="interim-form-container">
       <Helmet>
        <title>Vorlage Zwischenrechnung</title>
        <meta name="description" content="Auftrag bearbeiten" />
      </Helmet>
      <h1>{mode === "edit" ? "Vorlage Zwischenrechnung bearbeiten" : "Neuen Auftrag erstellen"}</h1>

       {mode === "edit" && (
      <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#555' }}>
        <div>
          <strong>Erstellt von:</strong>{' '}
          {interim.creator
            ? `${interim.creator.firstName} ${interim.creator.lastName}`
            : 'Unbekannt'}{' '}
          am {formatDateTime(interim.createdAt)}
        </div>
        <div>
          <strong>Zuletzt geändert von:</strong>{' '}
          {interim.updater
            ? `${interim.updater.firstName} ${interim.updater.lastName}`
            : 'Unbekannt'}{' '}
          am {formatDateTime(interim.updatedAt)}
        </div>
      </div>
    )}

      <div className="form-row">
        {/* Linke Spalte - Adressblock */}
        <div className="col">
          <label htmlFor="customerId" className="full-width">
            Kunde auswählen:
            <Select
              id="customerId"
              name="customerId"
              options={customerOptions}
              onInputChange={handleCustomerSearchChange}
              onChange={handleCustomerChange}
              value={customerOptions.find(option => option.value === interim.customerId) || null}
              className="select-box-cst"
              isClearable
              placeholder="Kunde suchen..."
            />
          </label>

          {/* Adressblock - Anzeige der Kundendaten */}
          {selectedCustomer && (
            <div className="customer-details">
              <p><strong>Firma:</strong> {selectedCustomer.company}</p>
              <p><strong>Zusatz:</strong> {selectedCustomer.companyAddon}</p>
              <p><strong>Anrede:</strong> {selectedCustomer.salutation} {selectedCustomer.firstName} {selectedCustomer.lastName}</p>
              <p><strong>Adresse:</strong> {selectedCustomer.street}, {selectedCustomer.postalCode} {selectedCustomer.city}</p>
              <TaxTreatmentFields document={interim} onChange={setInterim} customer={selectedCustomer} readOnly />

              {/* Button für TransportMarker */}
              

              

 <div className="checkbox-group" style={{ marginTop: '20px' }}>
  <div
    className="checkbox-list"
    style={{
      display: 'flex',
      flexDirection: 'column',    // <–– Items untereinander
      alignItems: 'center',       // <–– zentriert
      gap: '12px',                // <–– Abstand zwischen den Zeilen
      marginTop: '20px'
    }}
  >
    <label htmlFor="smartRental" className="checkbox-item">
      <input
        type="checkbox"
        id="smartRental"
        name="smartRental"
        checked={interim.smartRental}
        onChange={e =>
          setInterim(prev => ({ ...prev, smartRental: e.target.checked }))
        }
      />
      SmartRental
    </label>

    <label htmlFor="obligationInstruction" className="checkbox-item">
      <input
        type="checkbox"
        id="obligationInstruction"
        name="obligationInstruction"
        checked={interim.obligationInstruction}
        onChange={e =>
          setInterim(prev => ({ ...prev, obligationInstruction: e.target.checked }))
        }
      />
      Unterwpflicht
    </label>
  </div>
</div>

{/* Transportnotiz */}
<label htmlFor="notes" className="full-width" style={{ marginTop: '15px' }}>
              
              <textarea
                id="transportNotes"
                name="transportNotes"
                value={interim.transportNotes}
                onChange={handleChange}
                className="textarea-notes"
                rows="6"
                style={{ width: '60%', marginBottom: '20px', marginTop: '20px' }} // Breite kann hier angepasst werden
                placeholder="Transportnotiz"
              />
            </label>




            </div>
          )}

        </div>

      
        {/* Mittlere Spalte - Mietzeitraum */}
        <div className="col">
          
          <div>
            

            {/* Anlieferzeit Feld */}
            <label htmlFor="deliveryTime" className="full-width">
              Anlieferzeit:
              <input
                type="time"
                id="deliveryTime"
                name="deliveryTime"
                step="60" 
                value={interim.deliveryTime || ""}
                onChange={handleChange}
                className="input-box"
              />
            </label>

            {/* Einsatzort (operationLocation) */}
            <label htmlFor="operationLocation" className="full-width">
              Einsatzort:
              <input
                type="text"
                id="operationLocation"
                name="operationLocation"
                value={interim.operationLocation || ""}
                onChange={handleChange}
                className="input-box"
                placeholder="Strasse, PLZ, Ort"
              />
            </label>

            {/* Ansprechpartner vor Ort */}
            <label htmlFor="lwOperatorId" className="full-width">
              Ansprechpartner vor Ort:
              <select
                id="lwOperatorId"
                name="lwOperatorId"
                value={interim.lwOperatorId}
                onChange={handleLWOperatorChange}
                className="select-box"
                style={{ marginLeft: '0px' }}
              >
                <option value="">Bitte Ansprechpartner vor Ort wählen</option>
                {lwOperatorContacts.map((contact) => (
                  <option key={contact.id} value={contact.id}>
                    {contact.contactFirstName} {contact.contactLastName}
                  </option>
                ))}
              </select>
            </label>

             {/* Checkboxen unterhalb des Bestellers */}
             <div className="checkbox-group" >
                <h3>Als regulärer Miettag zählen:</h3>
                <div className="checkbox-list">
                  {/* Samstag Checkbox */}
                 <label htmlFor="includeSaturday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSaturday"
            name="includeSaturday"
            checked={tempIncludeSaturday}
            disabled // Immer deaktiviert!
          />
          Samstag
        </label>
                

                  {/* Sonntag Checkbox */}
                  <label htmlFor="includeSunday" className="checkbox-item">
          <input
            type="checkbox"
            id="includeSunday"
            name="includeSunday"
            checked={tempIncludeSunday}
            disabled // Immer deaktiviert!
          />
          Sonntag
        </label>

                  {/* Feiertage Checkbox */}
                   <label htmlFor="includeHolidays" className="checkbox-item">
          <input
            type="checkbox"
            id="includeHolidays"
            name="includeHolidays"
            checked={tempIncludeHolidays}
            disabled // Immer deaktiviert!
          />
          Feiertage
        </label>

                </div>

                {/* Neue Checkbox für Reservierung (falls benötigt, sonst entfernen) */}
                {/* Entfernt, da Interims keine Reservierung sind */}
              </div>

            {/* Auftragsnotiz */}
            <label htmlFor="notes" className="full-width" style={{ marginTop: '15px' }}>
              
              <textarea
                id="notes"
                name="notes"
                value={interim.notes}
                onChange={handleChange}
                className="textarea-notes"
                rows="7"
                style={{ width: '98%', marginBottom: '20px', marginTop: '20px' }} // Breite kann hier angepasst werden
                placeholder="Auftragsnotiz"
              />
            </label>
          </div>
          <div className="col"></div>

          {/* Auftragspositionen */}
          <div className="table-breakout" style={{ marginTop: '70px' }}>
            <h3>Auftragspositionen</h3>

            {/* Log vor der Tabelle */}
            {console.log("Aktuelle Auftragspositionen:", interimItems)}

            <table className="interim-positions-table" >
              <thead>
                <tr>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Position</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Artikel</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Beschreibung</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Einheit</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Menge</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>E-Preis</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>Gesamt</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Zeit Von</th>
                  <th>Zeit Bis</th>
                  <th style={{ bInterim: '1px solid #ddd', padding: '8px' }}>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {interimItems.map((position, index) => {
                  const isRental = position.item?.itemType === 'rental';
                  const isInsuranceItem = position.item?.itemType === 'insurance' || position.item?.itemType === 'insuranceFixed';
                  const editingThisRow = editingRowId === position.id;

                  const unitName =
                    position.item?.machineType?.typePricings?.[0]?.unit?.name ||
                    position.item?.transportPricings?.[0]?.unit?.name ||
                    (isInsuranceItem ? 'Prozent' : 'n.a.');

                  const pricePerUnit = Number(position.pricePerUnit) || 0;
                  const total = Number(position.total) || 0;


                  const isLinkedItem = !!position.mainItemId;

                  // Formatierung des Einzelpreises
                  const formattedPricePerUnit = (typeof pricePerUnit === 'number' && !isNaN(pricePerUnit))
                    ? pricePerUnit.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  // Formatierung des Gesamtpreises
                  const formattedTotal = (typeof total === 'number' && !isNaN(total))
                    ? total.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  return (
                    <tr key={position.id ?? position.tempId} style={isLinkedItem ? { paddingLeft: '20px' } : {}}>
                      {/* Positionsnummer */}
                      <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>{index + 1}</td>

                      {/* Artikelname */}
                      <td style={{ bInterim: '1px solid #ddd', padding: '8px', width: '25ch', minWidth: '25ch', maxWidth: '25ch' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <input
                            type="text"
                            value={position.item?.name || ''}
                            style={{ width: '25ch', minWidth: '25ch', maxWidth: '25ch' }}
                            onChange={(e) =>
                              setInterimItems((prev) =>
                                prev.map((item) =>
                                  item.id === position.id
                                    ? { ...item, item: { ...item.item, name: e.target.value } }
                                    : item
                                )
                              )
                            }
                          />
                        ) : (
                          <span
                            style={{
                              display: 'inline-block',
                              width: '25ch',
                              minWidth: '25ch',
                              maxWidth: '25ch',
                              whiteSpace: 'normal',
                              overflowWrap: 'anywhere',
                              wordBreak: 'break-all',
                            }}
                          >
                            {position.item?.name}
                          </span>
                        )}
                      </td>

                      {/* Beschreibung */}
                      <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
    <textarea
      value={position.description ?? position.item?.description ?? ''}
      wrap="soft"
      style={{ maxWidth: '320px' }}
      onChange={(e) =>
        setInterimItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { ...item, description: e.target.value }
              : item
          )
        )
      }
    />
  ) : (
    position.description || position.item?.description || 'Keine Beschreibung verfügbar'
  )}
</td>

                      {/* Einheit */}
<td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
  {position.unit?.name || ''}
</td>


                      {/* Menge */}
<td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
  {editingThisRow && !isInsuranceItem ? (
    <>
      <input
        type="number"
        value={position.quantity || ''}
        onChange={(e) => {
          const entered = parseFloat(e.target.value) || 0;
          const maxQty = getMaxAvailableQuantity(position);
          if (maxQty !== null && entered > maxQty) {
            alert(`Maximal verfügbare Menge: ${maxQty}`);
            return;
          }
          setInterimItems((prev) =>
            prev.map((item) =>
              item.id === position.id
                ? { ...item, quantity: entered, manualPriceActive: false }
                : item
            )
          );
        }}
        min="0"
        max={getMaxAvailableQuantity(position) || undefined}
      />
      <div style={{ fontSize: "0.8em", color: "#888" }}>
        Max: {getMaxAvailableQuantity(position) ?? "-"}
      </div>
    </>
  ) : (
    // Nur bei insurance (nicht insuranceFixed!) ein % anzeigen
    position.item?.itemType === 'insurance'
      ? `${position.quantity}%`
      : position.quantity
  )}
</td>



                      {/* Einzelpreis */}
<td style={{ bInterim: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>
  {(typeof position.pricePerUnit === 'number' && !isNaN(position.pricePerUnit))
    ? position.pricePerUnit.toFixed(2).replace('.', ',') + ' €'
    : '0,00 €'
  }
</td>

                      {/* Gesamtpreis */}
                      <td style={{ bInterim: '1px solid #ddd', padding: '8px', whiteSpace: 'nowrap' }}>
                          {typeof total === 'number' && !isNaN(total)
                            ? total.toFixed(2).replace('.', ',') + ' €'
                            : '0,00 €'}
                        </td>
                        {isRental && (
                        <>
                           {/* Mietzeitraum Von */}
                          <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
  {editingThisRow && isRental
    ? (
        // Eingabefeld für Mietartikel: immer DISABLED!
        <input
          type="date"
          value={position.rentalPeriodFrom || ''}
          disabled
        />
      )
    : editingThisRow && !isInsuranceItem
    ? (
        <input
          type="date"
          value={position.rentalPeriodFrom || ''}
          onChange={(e) =>
            setInterimItems((prev) =>
              prev.map((item) =>
                item.id === position.id
                  ? { ...item, rentalPeriodFrom: e.target.value }
                  : item
              )
            )
          }
        />
      )
    : (
        position.rentalPeriodFrom ? formatDate(position.rentalPeriodFrom) : '-'
      )
  }
</td>

                           {/* Mietzeitraum Bis */}
<td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <input
      type="date"
      value={position.rentalPeriodTo || ''}
      readOnly // Verhindert Benutzereingaben
      style={{
        backgroundColor: '#f5f5f5', // Optional: Zeigt visuell an, dass das Feld nicht bearbeitet werden kann
        cursor: 'not-allowed', // Zeigt einen visuellen Hinweis an, dass das Feld gesperrt ist
      }}
    />
  ) : (
    position.rentalPeriodTo ? formatDate(position.rentalPeriodTo) : '-'
  )}
</td>

                          {/* Mietzeit Von */}
                          <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
                          {editingThisRow && !isInsuranceItem ? (
                              <input
                                type="time"
                                value={position.rentalTimeFrom || ''}
                                onChange={(e) => {
                                  console.log('Änderung in rentalTimeFrom:', e.target.value); // Debugging
                                  setInterimItems((prev) =>
                                    prev.map((item) =>
                                      item.id === position.id
                                        ? { ...item, rentalTimeFrom: e.target.value }
                                        : item
                                    )
                                  );
                                }}
                              />
                            ) : (
                              position.rentalTimeFrom || '-'
                            )}
                          </td>

                          {/* Mietzeit Bis */}
                          <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
                          {editingThisRow && !isInsuranceItem ? (
                              <input
                                type="time"
                                value={position.rentalTimeTo || ''}
                                onChange={(e) =>
                                  setInterimItems((prev) =>
                                    prev.map((item) =>
                                      item.id === position.id
                                        ? { ...item, rentalTimeTo: e.target.value }
                                        : item
                                    )
                                  )
                                }
                              />
                            ) : (
                              position.rentalTimeTo || '-'
                            )}
                          </td>
                        </>
                      )}

                      {!isRental && (
                        <td colSpan={4} style={{ bInterim: '1px solid #ddd', padding: '8px' }}></td>
                      )}

                     {/* Aktionen */}
                     <td style={{ bInterim: '1px solid #ddd', padding: '8px' }}>
                     {editingThisRow ? (
                          <div style={{ display: 'flex' }}>
                            <button
                              type="button"
                              onClick={() => {
                                saveEditedRowInterim(position.id);   // EINZEL-EDIT-FUNKTION!
    setEditingRowId(null);
                              }}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#28a745',
                                color: '#fff',
                                bInterim: 'none',
                                bInterimRadius: '5px',
                              }}
                            >
                              Speichern
                            </button>
                            <button
                              type="button"
                              onClick={handleCancelEdit}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#6c757d',
                                color: '#fff',
                                bInterim: 'none',
                                bInterimRadius: '5px',
                                marginLeft: '10px',
                              }}
                            >
                              Abbrechen
                            </button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex' }}>
                            {/* Verstecke/Deaktiviere den Bearbeiten-Button, falls insurance */}
            {!isInsuranceItem && (
                            <button
                type="button"
                onClick={() => setEditingRowId(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#007bff',
                  color: '#fff',
                  bInterim: 'none',
                  bInterimRadius: '5px',
                  marginRight: '10px',
                }}
              >
                Bearbeiten
              </button>
              )}
                            <button
                              type="button"
                              onClick={() => removeInterimItem(position.id)}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#dc3545',
                                color: '#fff',
                                bInterim: 'none',
                                bInterimRadius: '5px',
                              }}
                            >
                              Löschen
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
             </div>

            {/* Gesamtsummen-Tabelle */}
            <div style={{ marginTop: '20px', width: '100%', maxWidth: '800px' }}>
              <h3>Zusammenfassung</h3>
              <table style={{ bInterimCollapse: 'collapse', width: '100%' }}>
                <tbody>
                  {/* Gesamt Netto */}
                  <tr>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>Gesamt Netto</td>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung von totalNet */}
                      {Number(interim.totalNet || 0).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>

                  {/* MwSt. */}
                  <tr>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>zzgl. MwSt. ({interim.vatRate ?? 19}%)</td>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung der MwSt. */}
                      {Number(interim.vatAmount || 0).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>

                  {/* Brutto */}
                  <tr>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>Rechnungsbetrag</td>
                    <td style={{ bInterim: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung des Bruttobetrags */}
                      {Number(interim.totalGross || 0).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
         

        </div>

        {/* Rechte Spalte - Auftragsnummer und Besteller */}
        <div className="col">

          <div style={{ marginBottom: '20px' }}>
  
</div>

          

           {/* Dropdown-Feld für Rechnungen */}
{interim.invoices && interim.invoices.filter(inv => !inv.creditNotes || inv.creditNotes.length === 0).length > 0 && (
  <div style={{ marginBottom: '20px' }}>
    <label htmlFor="invoiceDropdown" style={{ marginRight: '10px', fontWeight: 'bold' }}>
      
    </label>
    <select
      id="invoiceDropdown"
      onChange={(e) => {
        const selectedInvoiceId = e.target.value;
        if (selectedInvoiceId) {
          navigate(`/invoices/${selectedInvoiceId}/edit`);
        }
      }}
      style={{
        padding: '10px',
        bInterimRadius: '4px',
        bInterim: '1px solid #ccc',
        cursor: 'pointer',
        width: '250px',
      }}
    >
      <option value="">Rechnung wählen</option>
      {interim.invoices
        .filter(inv => !inv.creditNotes || inv.creditNotes.length === 0)
        .map((invoice) => (
          <option key={invoice.id} value={invoice.id}>
            {`${invoice.invoiceNumber || invoice.id} (${invoice.totalNet} €)`}
          </option>
        ))}
    </select>
    
  </div>
  
)}


          
          {/* Basis-Auftrag anzeigen */}
{interim.orderId && (
  <div style={{ marginBottom: '1rem' }}>
    <p>
      <strong>Basis-Auftrag ID:</strong> {interim.orderId}
      {interim.order?.orderNumber && (
        <> &nbsp;(<em>Nr. {interim.order.orderNumber}</em>)</>
      )}
    </p>
    {interim.order?.date && (
      <p>
        <strong>Auftragsdatum:</strong> {formatDate(interim.order.date)}
      </p>
    )}
  </div>
)}

{/* Zwischenabrechnung-Nummer */}
{interim.interimNumber && (
  <div style={{ marginBottom: '1rem' }}>
    <p><strong>Zwischenabrechnung-Nr.:</strong> {interim.interimNumber}</p>
  </div>
)}

{/* Bestellnummer (ReferenceNumber) */}
<label htmlFor="referenceNumber" className="full-width">
  <strong></strong>
  <input
    type="text"
    id="referenceNumber"
    name="referenceNumber"
    placeholder="Bestellnummer"
    value={interim.referenceNumber || ""}
    onChange={handleChange}
    className="input-box"
    style={{
          padding: '10px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          
          width: '250px',
        }}
  />
</label>


          {customerContacts.length > 0 ? (
            <>
              <label htmlFor="contactId" className="full-width">
                
                <select
                  id="contactId"
                  name="contactId"
                  value={interim.contactId}
                  onChange={handleContactChange}
                  className="select-box-bst"
                >
                  <option value="">Besteller wählen</option>
                  {customerContacts.map((contact) => (
                    <option key={contact.id} value={contact.id}>
                      {contact.contactFirstName} {contact.contactLastName}
                    </option>
                  ))}
                </select>
              </label>

              {/* Anzeige der Bestellerinformationen */}
              {selectedContact && (
                <div className="contact-details">
                  <p><strong>Name:</strong> {selectedContact.contactFirstName} {selectedContact.contactLastName}</p>
                  <p><strong>Mobil:</strong> {selectedContact.contactMobile}</p>
                  <p><strong>Email:</strong> {selectedContact.contactEmail}</p>
                  
                </div>
              )}

             
            </>
          ) : (
            <p>Keine Besteller verfügbar</p>
          )}
          
          <div style={{ textAlign: 'center' }}>
  
  </div>

        </div>
        
      </div>

      <div className="actions">
      {/*  <button type="button" onClick={handleBackButtonClick} style={{ marginRight: '10px', padding: '10px 20px', cursor: 'pointer' }}>
          Zurück
        </button>*/}
        <button type="button" onClick={handleSave} style={{ padding: '10px 20px', cursor: 'pointer' }}>
          {mode === "edit" ? "Speichern" : "Erstellen"}
        </button>
      </div>

      
        





    </div>
  );
};

export default InterimForm;
